// Public suppression list: ids of suspended sellers. Grids are already filtered
// server-side (/cars/lite); this hook lets detail/seller pages hide direct deep-links.
import { useEffect, useState } from "react";

const BASE = process.env.REACT_APP_BACKEND_URL;
let _cache = null;
let _exp = 0;

export async function fetchSuspendedIds() {
  if (_cache && _exp > Date.now()) return _cache;
  try {
    const res = await fetch(`${BASE}/api/public/suspended-sellers`, { headers: { Accept: "application/json" } });
    const d = await res.json();
    _cache = new Set(d.ids || []);
  } catch {
    _cache = new Set();
  }
  _exp = Date.now() + 60000;
  return _cache;
}

export function useSuspended() {
  const [ids, setIds] = useState(_cache || new Set());
  useEffect(() => {
    let alive = true;
    fetchSuspendedIds().then((s) => { if (alive) setIds(s); });
    return () => { alive = false; };
  }, []);
  return ids;
}
